(() => {
  'use strict';
  const init = (scope = document) => {
    scope.querySelectorAll('[data-nxs-sizing]').forEach((root) => {
      if (root.dataset.nxsReady === 'true') return;
      root.dataset.nxsReady = 'true';
      const tabs = [...root.querySelectorAll('[data-nxs-tab]')];
      const panels = [...root.querySelectorAll('[data-nxs-tab-panel]')];
      const sizeButtons = [...root.querySelectorAll('[data-nxs-size]')];
      const activateTab = (button, focus = false) => {
        if (!button) return;
        const key = button.dataset.nxsTab;
        tabs.forEach((tab) => {
          const active = tab === button;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });
        panels.forEach((panel) => {
          const active = panel.dataset.nxsTabPanel === key;
          panel.hidden = !active;
          panel.setAttribute('aria-hidden', String(!active));
        });
        if (focus) button.focus();
      };
      tabs.forEach((button, index) => {
        button.addEventListener('click', () => activateTab(button));
        button.addEventListener('keydown', (event) => {
          if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          activateTab(tabs[next], true);
        });
      });
      const initial = tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || tabs[0];
      if (initial) activateTab(initial);
      sizeButtons.forEach((button) => {
        button.addEventListener('click', () => {
          sizeButtons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        });
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
